import { ADD_API_TOKEN, CREATE_SYNDI_CLICK_SOURCE_TYPE, DELETE_API_TOKEN, GET_API_TOKEN, GET_SYNDI_CLICK_ADMIN_SETTINGS, GET_SYNDI_CLICK_SETTINGS, GET_SYNDI_CLICK_SOURCE_TYPES, MODIFY_API_TOKEN, MODIFY_SYNDI_CLICK_ADMIN_SETTINGS, MODIFY_SYNDI_CLICK_SETTINGS } from "./actionTypes"
import { call, put, takeEvery } from "redux-saga/effects"
import { createApiTokenError, createApiTokenSuccess, createSyndiClickSourceTypeError, createSyndiClickSourceTypeSuccess, deleteApiTokenError, deleteApiTokenSuccess, getApiTokenError, getApiTokenSuccess, getSyndiClickAdminSettingsError, getSyndiClickAdminSettingsSuccess, getSyndiClickSettingsError, getSyndiClickSettingsSuccess, getSyndiClickSourceTypesError, getSyndiClickSourceTypesSuccess, modifyApiTokenError, modifyApiTokenSuccess, modifySyndiClickAdminSettingsError, modifySyndiClickAdminSettingsSuccess, modifySyndiClickSettingsError, modifySyndiClickSettingsSuccess } from "./actions"
import { AppConfiguration } from "config";
import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";

function* onGetAPITokens() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/api_tokens`,
      {},
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getApiTokenSuccess(response?.tokens || []))
  } catch (error) {
    yield put(getApiTokenError(error))
  }
}

function* onCreateAPITokens(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/api_tokens`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createApiTokenSuccess(response))
  } catch (error) {
    yield put(createApiTokenError(error))
  }
}

function* onUpdateAPITokens(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/api_tokens/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(modifyApiTokenSuccess(response))
  } catch (error) {
    yield put(modifyApiTokenError(error))
  }
}

function* onDeleteteAPIToken(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/api_tokens/${action.payload.id}`,
      {
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(deleteApiTokenSuccess({ ...response, _id: action.payload.id }))
  } catch (error) {
    yield put(deleteApiTokenError(error))
  }
}

function* onGetSyndiClickSettings(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/syndi_click_settings`,
      action.payload,
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSyndiClickSettingsSuccess(response))
  } catch (error) {
    yield put(getSyndiClickSettingsError(error))
  }
}

function* onUpdateSyndiClickSettings(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const syndi_clicks_token_or_campaign_id = action?.payload?.token_id ? action.payload.token_id : action?.payload?.campaign_id
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/syndi_click_settings/${syndi_clicks_token_or_campaign_id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          "brand-id": getCurrentBrandFromLocalStorage()?.id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(modifySyndiClickSettingsSuccess(response))
  } catch (error) {
    yield put(modifySyndiClickSettingsError(error))
  }
}

function* onGetSyndiClickAdminSettings(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_syndi_click_campaign_settings`,
      action.payload,
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        "brand-id": getCurrentBrandFromLocalStorage()?.id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSyndiClickAdminSettingsSuccess(response))
  } catch (error) {
    yield put(getSyndiClickAdminSettingsError(error))
  }
}

function* onUpdateSyndiClickAdminSettings(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/update_syndi_click_campaign_settings`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          "brand-id": getCurrentBrandFromLocalStorage()?.id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(modifySyndiClickAdminSettingsSuccess(response))
  } catch (error) {
    yield put(modifySyndiClickAdminSettingsError(error))
  }
}

function* onGetSyndiClickSourceTypes() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/syndi_click_source_types`,
      {},
      {
        'Authorization': user.token,
        'account-id': user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getSyndiClickSourceTypesSuccess(response))
  } catch (error) {
    yield put(getSyndiClickSourceTypesError(error))
  }
}

function* onCreateSyndiClickSourceType(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/syndi_click_source_types`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(createSyndiClickSourceTypeSuccess(response))
    ToastAlert.fire({ icon: ToastAlertIconType.OK, title: "Source Type Created Successfully" })
  } catch (error) {
    yield put(createSyndiClickSourceTypeError(error))
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Something Went Wrong!' })
  }
}

function* APITokensSaga() {
  yield takeEvery(GET_API_TOKEN, onGetAPITokens);
  yield takeEvery(ADD_API_TOKEN, onCreateAPITokens);
  yield takeEvery(MODIFY_API_TOKEN, onUpdateAPITokens);
  yield takeEvery(DELETE_API_TOKEN, onDeleteteAPIToken);
  yield takeEvery(GET_SYNDI_CLICK_SETTINGS, onGetSyndiClickSettings)
  yield takeEvery(MODIFY_SYNDI_CLICK_SETTINGS, onUpdateSyndiClickSettings)
  yield takeEvery(GET_SYNDI_CLICK_ADMIN_SETTINGS, onGetSyndiClickAdminSettings)
  yield takeEvery(MODIFY_SYNDI_CLICK_ADMIN_SETTINGS, onUpdateSyndiClickAdminSettings)
  yield takeEvery(GET_SYNDI_CLICK_SOURCE_TYPES, onGetSyndiClickSourceTypes)
  yield takeEvery(CREATE_SYNDI_CLICK_SOURCE_TYPE, onCreateSyndiClickSourceType)
}

export default APITokensSaga;
